import {Navigate} from 'react-router'
import {useSchools} from '@freckle/educator-entities/ts/common/hooks/use-schools'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import {Routes} from '@freckle/school/ts/common/routers/routes'

export default function RedirectAuthenticatedComponentHandler() {
  const schools = useSchools()
  return (
    <WithResources
      resources={{schools}}
      render={({schools}) => {
        const firstSchool = schools[0]
        if (firstSchool === undefined) {
          return <Navigate to={Routes.noSchools()} replace />
        }
        return <Navigate to={Routes.dashboard()} replace />
      }}
    />
  )
}
